import { render, staticRenderFns } from "./trustpilot-widget.vue?vue&type=template&id=6cc4af60&"
import script from "./trustpilot-widget.vue?vue&type=script&lang=js&"
export * from "./trustpilot-widget.vue?vue&type=script&lang=js&"
import style0 from "./trustpilot-widget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports